import { useEffect, useState } from "react";
import { useProductsQuery } from "../../../../saleor/api";
import { mapEdgesToNodes } from "../../../../base/utils";
import { ProductTransformer } from "../../../../services/objectTransformer/products";
import { Note } from "../../../../helbest";
import { useSelector } from "react-redux";

export const useSlider = ({ productSliders = [] }) => {
  const [sliders, setSliders] = useState(productSliders ?? []);
  const { channel } = useSelector((state) => state.Login);

  const { data } = useProductsQuery({
    variables: {
      channel,
      filter: {
        ids: [...new Set(productSliders.map((product) => product.id))],
      },
      first: 100,
    },
    skip: !productSliders.length,
    onError: (error) => {
      Note.error(error.message);
    },
  });

  useEffect(() => {
    if (data) {
      const products = mapEdgesToNodes(data.products.edges, ProductTransformer);

      let newSliders = [...sliders];
      newSliders = newSliders.map((productItem) => {
        if (
          newSliders.map((sliderItem) => sliderItem.id).includes(productItem.id)
        ) {
          const currentProduct = products.find(
            (product) => product.id === productItem.id
          );
          productItem = {
            ...productItem,
            ...currentProduct,
          };
        }
        return productItem;
      });
      setSliders(newSliders);
    }
    // eslint-disable-next-line
  }, [data]);

  return [sliders];
};
